import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AlCompanyService } from '../../services/al-company.service';
import { BehaviorSubject } from 'rxjs';
import { UserCompanyAccessRequest } from '../../interfaces/user-company-access-request.interface';
import { DxDataGridModule } from 'devextreme-angular';
import { showErrorSwal } from '@asamco/utils';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-company-access-requests',
	standalone: true,
	imports: [
		CommonModule,
		DxDataGridModule
	],
	templateUrl: './company-access-requests.component.html',
	styleUrl: './company-access-requests.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAccessRequestsComponent implements OnInit {
	requests$ = new BehaviorSubject<UserCompanyAccessRequest[]>(undefined);

	constructor(private companyService: AlCompanyService) {}

	ngOnInit(): void {
		this.companyService.getPendingAccessRequests().subscribe(r => this.requests$.next(r));
	}

	handleRequest(requestId: number, granted: boolean) {
		this.companyService.handleAccessRequest(requestId, granted).subscribe({
			next: r => {
				Swal.fire(`Acccess request ${granted ? 'granted' : 'denied'}`, '', 'success');
				this.requests$.next(this.requests$.value.filter(r => r.requestId !== requestId));
			},
			error: showErrorSwal
		});
	}
 }
